var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRelaxed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 61 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    x: 2,
    y: 2,
    fill: "#fff",
    rx: 8.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F35C5C",
    fillRule: "evenodd",
    d: "M31.1 59c0-16-13-29.1-29.1-29.1v-18c26 0 47.2 21 47.2 47.1h-18Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F35C5C",
    fillRule: "evenodd",
    d: "M15.8 59c0-7.6-6.2-13.8-13.8-13.8v-8.6c12.3 0 22.3 10 22.3 22.4h-8.5Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F1E5F",
    fillRule: "evenodd",
    d: "M27.5 31.9a5 5 0 0 0 7-.2l2.2 2.1a8 8 0 0 1-11.3.3l2-2.2Zm10.9-11.4a5 5 0 0 0 7-.2l2.3 2.1a8 8 0 0 1-11.4.4l2.1-2.3Zm-22.4.4a5 5 0 0 0 7.1-.2l2.3 2.1a8 8 0 0 1-11.4.3l2-2.2Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRelaxed);
export default __webpack_public_path__ + "static/media/icon-relaxed.c5380e533c770e988aa4118f75cb12c4.svg";
export { ForwardRef as ReactComponent };